module.exports = ""


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/org-h/org-h.component.html
// module id = ../../../../../src/app/pages/history/org-h/org-h.component.html
// module chunks = main